import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { getContentType } from '../../../Utils/helper';
import { GridWrapper } from '../../StoreHomePage/BannersGrid/styled';
import Card from './Card';
import LoadMore from './LoadMore';
import {
  MostReadArticle,
  SimilarVideoSection,
  SimilarVideoTitle,
} from './styled';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function ArticlesAndVideos(props) {
  const { articleVideoData, showLoader, stage } = props;
  const fetchData = () => {
    const content = [];
    articleVideoData?.items?.map((element) => {
      content.push(element?.content);
    });
    return content;
  };
  const [showLoadMore, setShowLoadMore] = useState(true);

  const { data, error, mutate } = useSWR(
    `data_${articleVideoData?.itemId}`,
    () => {
      // console.log("");
    },
    {
      fallbackData: fetchData(),
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
    },
  );

  useEffect(() => {
    if (articleVideoData?.items?.length > 0) {
      let cardId = [];
      articleVideoData?.items?.forEach((element) => {
        cardId.push(element?.content?.primary_tag_id);
      });
      fireServedSectionEvent(
        articleVideoData?.heading,
        cardId,
        getContentType(),
      );
    }
  }, []);

  return (
    <GridWrapper>
      <div>
        <SimilarVideoTitle>{articleVideoData?.heading}</SimilarVideoTitle>
        <MostReadArticle>{articleVideoData?.subHeading}</MostReadArticle>
      </div>
      <SimilarVideoSection>
        {data?.map((data, index) => {
          return (
            <Card
              primaryTagId={data?.primary_tag_id}
              index={index}
              cardData={data?.content}
              contentType={data?.content_type}
              heading={data?.heading}
              key={index}
            />
          );
        })}
      </SimilarVideoSection>
      {showLoadMore ? (
        <LoadMore
          contentArray={data}
          data={data?.items}
          showLoader={showLoader}
          setShowLoadMore={setShowLoadMore}
          heading={data?.heading}
          mutate={mutate}
          stage={stage}
        />
      ) : null}
    </GridWrapper>
  );
}
